import { IChuanDauRaChungChiActionTypes } from "../../action-types/chuong-trinh-dao-tao/IChuanDauRaChungChiActions";
import { IChuanDauRaChungChiReducer } from "../../reducer-model/chuong-trinh-dao-tao/IChuanDauRaChungChiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: IChuanDauRaChungChiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    chuanDauRaChungChis: [],
}

export const chuanDauRaChungChiReducer = (state: IChuanDauRaChungChiReducer = initialState, action: IChuanDauRaChungChiActionTypes): IChuanDauRaChungChiReducer => {
    switch (action.type) {
        case "CHUAN_DAU_RA_CHUNG_CHI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUAN_DAU_RA_CHUNG_CHI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chuanDauRaChungChis: action.payload,
            };
        case "CHUAN_DAU_RA_CHUNG_CHI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUAN_DAU_RA_CHUNG_CHI_SYS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "CHUAN_DAU_RA_CHUNG_CHI_SYS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CHUAN_DAU_RA_CHUNG_CHI_SYS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;   
    }
}